// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"351":"f3a86a0c","581":"1fc0bfd6","591":"b372ca4e","606":"0d2b535b"}[chunkId] + ".chunk.css";
};